const SocialConnectCard = () => (
  <div className="absolute inset-0">
    <svg viewBox="0 0 400 300" xmlns="http://www.w3.org/2000/svg" className="h-full w-full">
      <defs>
        <linearGradient id="scBg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#EDE9FE" />
          <stop offset="50%" stopColor="#C4B5FD" />
          <stop offset="100%" stopColor="#A78BFA" />
        </linearGradient>
        <linearGradient id="scIg" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#FFDC80" />
          <stop offset="35%" stopColor="#F56040" />
          <stop offset="100%" stopColor="#833AB4" />
        </linearGradient>
      </defs>

      {/* Background */}
      <rect width="400" height="300" fill="url(#scBg)" />

      {/* Card 1: Connect your socials (expanded) */}
      <rect x="18" y="14" width="364" height="172" rx="14" fill="white" />

      {/* Icon box */}
      <rect x="30" y="26" width="32" height="32" rx="8" fill="#F1F5F9" />
      <path d="M51 35c1.5-1.5 4-1.5 5.5 0s1.5 4 0 5.5l-2 2c-1.5 1.5-4 1.5-5.5 0" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      <path d="M49 45c-1.5 1.5-4 1.5-5.5 0s-1.5-4 0-5.5l2-2c1.5-1.5 4-1.5 5.5 0" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      <line x1="47.5" y1="36.5" x2="52.5" y2="41.5" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round"/>

      <text x="70" y="38" fontFamily="Inter,sans-serif" fontSize="11.5" fontWeight="700" fill="#111827">Connect your socials</text>
      <text x="70" y="51" fontFamily="Inter,sans-serif" fontSize="9" fill="#9CA3AF">We Only Use Publicly Available Data To Train Your AI</text>
      <text x="370" y="38" fontFamily="sans-serif" fontSize="11" fill="#9CA3AF" textAnchor="middle">∧</text>

      {/* YouTube input */}
      <rect x="28" y="68" width="344" height="28" rx="9" fill="white" stroke="#E5E7EB" strokeWidth="1" />
      <rect x="37" y="74" width="16" height="16" rx="4" fill="#FF0000" />
      <polygon points="48,82 43,79 43,85" fill="white" />
      <text x="60" y="85" fontFamily="Inter,sans-serif" fontSize="10" fill="#9CA3AF">@yourhandle</text>

      {/* Instagram input */}
      <rect x="28" y="103" width="344" height="28" rx="9" fill="white" stroke="#E5E7EB" strokeWidth="1" />
      <rect x="37" y="109" width="16" height="16" rx="5" fill="url(#scIg)" />
      <rect x="40" y="112" width="10" height="10" rx="3" stroke="white" strokeWidth="1.2" fill="none" />
      <circle cx="47" cy="117" r="2.5" stroke="white" strokeWidth="1.2" fill="none" />
      <circle cx="49" cy="113" r="1" fill="white" />
      <text x="60" y="120" fontFamily="Inter,sans-serif" fontSize="10" fill="#9CA3AF">@yourhandle</text>

      {/* LinkedIn input */}
      <rect x="28" y="138" width="344" height="28" rx="9" fill="white" stroke="#E5E7EB" strokeWidth="1" />
      <rect x="37" y="144" width="16" height="16" rx="4" fill="#0A66C2" />
      <text x="40" y="155" fontFamily="Arial,sans-serif" fontSize="10" fontWeight="800" fill="white">in</text>
      <text x="60" y="155" fontFamily="Inter,sans-serif" fontSize="10" fill="#9CA3AF">@yourhandle</text>

      {/* Card 2: Add a website URL (collapsed) */}
      <rect x="18" y="196" width="364" height="62" rx="14" fill="white" />

      <rect x="30" y="208" width="32" height="32" rx="8" fill="#F1F5F9" />
      <circle cx="46" cy="224" r="10" stroke="#64748B" strokeWidth="1.5" fill="none" />
      <ellipse cx="46" cy="224" rx="4" ry="10" stroke="#64748B" strokeWidth="1.5" fill="none" />
      <line x1="36" y1="224" x2="56" y2="224" stroke="#64748B" strokeWidth="1.5" />

      <text x="70" y="220" fontFamily="Inter,sans-serif" fontSize="11.5" fontWeight="700" fill="#111827">Add a website URL</text>
      <text x="70" y="233" fontFamily="Inter,sans-serif" fontSize="9" fill="#9CA3AF">Fetch Content From Your Existing Website (If Any)</text>
      <text x="370" y="220" fontFamily="sans-serif" fontSize="11" fill="#9CA3AF" textAnchor="middle">∨</text>
    </svg>
  </div>
);

export default SocialConnectCard;
